import { memo } from 'react'
import { EditorProps } from 'react-data-grid'
import Modal from './Modal'
import { SummaryReceiptRow } from "../constants/Column"
import { OrderReceipt } from "./types"
import { calculateYieldFilling } from '../logic/yield'
import { formatNumberDigit } from '../utilities/Format'
import { FaCalculator } from 'react-icons/fa'

const ShowInfoEditor = memo(({ title, props } : {
  title: string
  props: EditorProps<OrderReceipt, SummaryReceiptRow>
}) => {
  const { onClose, row } = props

  return <Modal show={true} onHide={onClose}
    okTheme='info'
    cancelText='ปิด'
    title={title}
    maxWidth={' max-w-3xl'}
    TitleIcon={FaCalculator}
    >
    <>
      <div>
        <p className='font-bold '>สูตรคำนวณ</p>
        <p>% YIELD = จำนวนผลิตได้จริงทั้งหมด (EA) x ค่าเฉลี่ย Filling Weight (KG) / น้ำหนัก BULK (KG)</p>
      </div>
      <div className='mt-2 '>
        <p className='font-bold '>คำนวนจริง</p>
        <p>% YIELD = {row.totalAmount} x {formatNumberDigit(row.avgFillingWeight, 2)} / ({formatNumberDigit(row.bulkUsage, 3)}/1000) x 100 = <span className='font-bold underline decoration-double '>{formatNumberDigit(calculateYieldFilling(row), 2)} %</span></p>
      </div>
      <div className='mt-2 '>
        <p className='font-bold '>หมายเหตุ</p>
        <p>100+5%,-5%</p>
      </div>
    </>
  </Modal>
})

export default ShowInfoEditor